import {locations} from '@jobseeker/lotus/components/JobSearchBar/data';
import {enqueueSnackbar} from 'notistack';
export * from './mapper';

// TODO: ADD UTILS FUNCTIONS

const isCSR = () => {
  return typeof window !== 'undefined';
};
export const removeLinks = (htmlString: string): string => {
  return htmlString
    .replace(/<a\b[^>]*>([\s\S]*?)<\/a>/gi, '$1')
    .replace(/&nbsp;/gi, ' ')
    .replace(/&#160;/gi, ' ');
};

export const formatSalaryInLacs = (salary: number): string => {
  if (salary < 100000) {
    return '< 1 Lacs';
  } else if (salary >= 10000000) {
    const crores = Math.floor((salary / 10000000) * 100) / 100;
    return crores.toFixed(2) + ' Crore';
  } else {
    const lacs = Math.floor((salary / 100000) * 100) / 100;
    return lacs.toFixed(2) + ' Lacs';
  }
};

export const customKebab = (title?: string | null): string => {
  if (!title) return '';
  const title_clean = cleanUrl(htmlentities(title));
  return removeDoubleDashes(title_clean);
};

const getReplacedString = (
  text: string,
  value: string,
  replacement: string
) => {
  if (text.includes(value) && replacement) {
    const replacedVal = text.replace(value, replacement);
    if (parseInt(replacement) < 2) {
      return replacedVal.replace('invites!', 'invite!');
    }

    return replacedVal;
  }

  return text;
};

const getOldLink = (path: string) => {
  return path; //`${process.env.NEXT_PUBLIC_OLD_APP_URL}${path}`;
};

const getProLink = (
  page: string,
  reCap: string,
  refCode: string,
  refFeature = ''
) => {
  const link = `${process.env.NEXT_PUBLIC_UPGRADE_PRO}?recappid=${reCap}&refcode=${refCode}&pageid=${page}`;

  return !refFeature ? link : `${link}&reffeature=${refFeature}`;
};

export const getRefFromPath = () => {
  if (window && window.location) {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get('ref');
  }
  return '';
};

const locationMap = (value: any) => {
  console.log('🚀 ~ file: index.ts:46 ~ locationMap ~ value:', value);
  let locationString = '';

  value.forEach((location: any) => {
    locations.forEach(locObj => {
      if (location === locObj?.value) {
        if (locationString) {
          locationString = `${locationString}_${locObj?.label}`;
        } else {
          locationString = locObj?.label;
        }
      }
    });
  });

  return locationString;
};

const truncateString = (str: string, index: number) => {
  if (str.length <= index) {
    return str;
  }

  return str.slice(0, index) + '...';
};

export const getMediaPermission = (
  permissions = {
    video: true,
    audio: true,
  },
  callback: (k: any) => void,
  errCallback: (k: boolean) => void
) => {
  console.log('getMediaPermission', navigator);
  navigator.mediaDevices
    .getUserMedia(permissions)
    .then(() => {
      callback(permissions);
    })
    .catch(error => {
      if (error.name === 'NotAllowedError') {
        errCallback(true);
      } else {
        errCallback(true);
        console.error(error);
      }
    });
};

export const getFileNameFromFileUrl = (url: string) => {
  const fileName = url?.split('/')?.pop() ?? '';
  return fileName.split('?')[0];
};

export const getFileBlobFromUrl = async (url: string) => {
  const fileResp = await fetch(url);
  const blob = await fileResp.blob();
  return blob;
};

export const formatBytes = (bytes: number, decimals: number = 2) => {
  if (!+bytes) return '0 Bytes';

  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

  const i = Math.floor(Math.log(bytes) / Math.log(k));

  return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`;
};

// Map of characters to replace
const replacements: Record<string, string> = {
  '–': '',
  ' ': '-',
  '--': '-',
  '&quot;': '',
  '!': '',
  '@': '',
  '#': '',
  $: '',
  '%': '',
  '^': '',
  '&': '',
  '*': '',
  '(': '',
  ')': '',
  _: '',
  '+': '',
  '{': '',
  '}': '',
  '|': '',
  ':': '',
  '"': '',
  '<': '',
  '>': '',
  '?': '',
  '[': '',
  ']': '',
  '\\': '',
  ';': '',
  "'": '',
  ',': '',
  '.': '',
  '/': '-',
  '~': '',
  '`': '',
  '=': '',
};

// Escape special characters in the keys for regex
const escapeRegex = (str: string) =>
  str.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&');

const regexPattern = new RegExp(
  Object.keys(replacements).map(escapeRegex).join('|'),
  'g'
);

const cleanUrl = (text: string): string => {
  if (!text) {
    return '';
  }

  // Trim and convert to lowercase
  text = text?.trim().toLowerCase();

  // Replace matches using the map
  const value = text?.replace(regexPattern, match => replacements[match] || '');

  return regexPattern.test(value) ? cleanUrl(value) : value;
};

const showSnackbar = (msg: string, options: any) => {
  enqueueSnackbar(msg, options);
};

/**
 * Replaces multiple consecutive hyphens (`--`) with a single hyphen (`-`).
 *
 * @param text - The input string containing hyphens.
 * @returns A new string with all consecutive hyphens reduced to a single hyphen.
 *
 * @example
 * ```ts
 * replaceConsecutiveHyphensWithOne("hello--world---test"); // "hello-world-test"
 * replaceConsecutiveHyphensWithOne("a---b--c"); // "a-b-c"
 * ```
 */
const replaceConsecutiveHyphensWithOne = (text: string): string => {
  return text.replace(/-+/g, '-');
};

export {
  isCSR,
  getReplacedString,
  getOldLink,
  getProLink,
  locationMap,
  truncateString,
  cleanUrl,
  showSnackbar,
  replaceConsecutiveHyphensWithOne,
};

export {forwardQueryParamIfMatches} from './refUtils';

export const addUtmParamsToUrl = (
  url: any,
  source: any,
  isDesktop: boolean
) => {
  let finalUrl = url;
  const app = process.env.NEXT_PUBLIC_APP_NAME;

  //utm_source
  finalUrl += `?utm_source=${app}`;

  //utl_medium
  if (isDesktop) {
    finalUrl += '&utm_medium=desktop';
  } else {
    finalUrl += '&utm_medium=mobileWeb';
  }

  //utl_campaign
  if (source == 'RATING_REVIEWS') {
    //for rating reviews count info
    finalUrl += `&utm_campaign=${app}_comp_ratings`;
  } else if (source == 'BENEFITS') {
    //for benefits
    finalUrl += `&utm_campaign=${app}_comp_benefits`;
  } else if (source == 'TOP_JOB_PROFILES') {
    //for topJobProfile
    finalUrl += `&utm_campaign=${app}_comp_jp_reviews`;
  } else if (source == 'JD_RATING_REVIEWS') {
    // for rating reviews redirection to ambition box from JD
    finalUrl += `&utm_campaign=jd_ratings_${app}`;
  }

  return finalUrl;
};

export const getNestedProperty = (obj: any, path: any) => {
  return path.split('.').reduce((acc: any, key: any) => {
    return acc && acc[key] !== undefined && acc[key] !== null
      ? acc[key]
      : undefined;
  }, obj);
};

export const getBarColor = (percentage: number) => {
  return percentage >= 0 && percentage <= 35
    ? '#FF0000'
    : percentage >= 36 && percentage <= 80
      ? '#FFBC5E'
      : '#1BD38F';
};

export const htmlentities = (str: string): string => {
  const entities: {[key: string]: string} = {
    '&': '&and;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#039;',
  };
  return str.replace(/[&<>"']/g, match => entities[match] || match);
};

export const removeDoubleDashes = (str: string): string => {
  while (str.includes('--')) {
    str = str.replace(/--/g, '-');
  }
  return str;
};
